export default {
  badge: 'Configuration',
  title: 'Terminez la configuration de votre restaurant',
  description: 'Quelques étapes restantes avant que votre restaurant puisse passer en ligne.',
  count: '{{done}} sur {{total}} étapes effectuées',
  cta: 'Continuer la configuration',
  done: {
    badge: 'Tout est prêt',
    title: 'Tout est prêt',
    description: '{{partner}} mettra votre restaurant en ligne.',
    fallback_partner: 'Votre prestataire',
  },
};
